module.exports = __webpack_public_path__ + "static/media/grid-item-c3.56fbd964.png";